import React, { useState, useEffect, useRef, useContext } from "react";
import { translateCol } from "../../../../custom/columnI18n";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Dropdown } from 'primereact/dropdown';
import { Column } from "primereact/column";
import { useSelector } from "react-redux";
import { AuthContext } from "../../../../Header/auth - context";
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { InputText } from 'primereact/inputtext';
import { Divider } from 'primereact/divider';
import ConfirmationModalBonitet from '../../../../custom/ConfirmationModalBonitet';
import useVisinaTabele from "../../../../custom/visinaTabele";

const BonitetProvera = (props) => {
  const { t } = useTranslation();
    const toast = useRef(null);
    const auth = useContext(AuthContext);
    const company = useSelector(state => state.company);       
    const user = useSelector(state => state.user)
    const [pib, setPIB] = useState(null)
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [bonitetData, setBonitetData] = useState(null);


    //tab kontrole
          const pregledOptions = [{value:1, label:"Subjekat"},{value:2, label:"Nbs status"},{value:3, label:"Nbs blokade"},{value:4, label:"Pdv status"},{value:5, label:"Bonitet"},{value:6, label:"Bonitet istorija"},{value:7, label:"Vlasnici"}
            ,{value:8, label:"Zastupnici"},{value:9, label:"Oduzet PIB"},{value:10, label:"Tekući računi"},{value:11, label:"Izvršenja"},{value:12, label:"Povezana preduzeća"},{value:13, label:"Finansijski podaci"}
            ,{value:14, label:"Zaloge"},{value:15, label:"Dnevna blokada"},{value:16, label:"Kontakt"},{value:17, label:"Zabeležbe"},{value:18, label:"Imovina"},{value:19, label:"Sudski predmeti"},
            {value:20, label:"Kapital"},{value:21, label:"Poslovanje"},{value:22, label:"AOP Istorija"}]
    const [izabranPregled, setIzabranPregled] = useState(1);

    const handleChangePregled = (e) => {
        setIzabranPregled(e.value)
    }

  const [tableData, setTableData] = useState(null);
  const [allColumns, setAllColumns] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [first, setFirst] = useState(0);
  const getId = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null; // ➜ stabilan ključ
  const [selectedRowId , setSelectedRowId] = useState(null);
  const isSelected = (row) => String(getId(row)) === String(selectedRowId);
  const [izabran, setIzabran] = useState(false)
  /* Spisak se zavrsava na dnu ekrana; visina se MERI, ne pogadja. */
  const [omotTabele, visinaTabele, redovaTabele] = useVisinaTabele([tableData, izabran]);

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
 

const getConfigColumns = async () => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + auth.token,
    },
    body: JSON.stringify({
      id_config: 274 + izabranPregled
    }),
  };

    const data = await fetch(process.env.REACT_APP_BACKEND_URL + "/config/", requestOptions)
      .then(handleErrors); 

    if (data.message) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: data.message,
        life: 3000,
      });
      return { empty: true, data: [] };
    }

     if(data.length > 0) {
                    return { empty: false, data: data };
                } else {
                    return { empty: true, data: [] };
                }


};

  useEffect(() => {
    
    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        report: izabranPregled
      }),
    };
    
     fetch(process.env.REACT_APP_BACKEND_URL + "/bonitet/", requestOptions)
      .then(handleErrors)
      .then(async (data) => {
        setTableData(data);
        
          // Extract all available columns from the first data row
            if (data && data.length > 0) {
              const columns = Object.keys(data[0])
                .filter(key => !['ID'].includes(key))
                .map(key => ({ label: key, value: key }));

              setAllColumns(columns);
              const originalOrder = Object.keys(data[0]);
              setOriginalColumnOrder(originalOrder);

              const columnsDB = await getConfigColumns();

              if (!columnsDB.empty && columnsDB.data.length > 0) {
                const arr = JSON.parse(columnsDB.data[0].parametri);
                setSelectedColumns(arr);
              } else {
                setSelectedColumns(columns.slice(0, 5).map(col => col.value));
              }
            }
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });
  }, [izabranPregled]);

    const getPregledLabel = (value) => {
    const found = pregledOptions.find(p => p.value === value);
    return found ? found.label : '';
    };

  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;

      const pregledLabel = getPregledLabel(izabranPregled);
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(pregledLabel);
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns.map(c => translateCol(t, c));
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `${pregledLabel} - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
          <div className="fakture-stavke-radnje">
              <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
          </div>
          <input
               type="search"
               onInput={(e) => setGlobalFilter(e.target.value)}
               placeholder={t('nova.phPretraga')}
               className="p-inputtext p-component"
               />
      </div>
      );
      
  const handleSaveConfig = () => {
         confirmDialog({
                    message: "Jel ste sigurni da želite sačuvati konfiguraciju?",
                    acceptLabel: "Da",
                    rejectLabel: "Ne",
                    icon: "pi pi-info-circle",
                    acceptClassName: "p-button-danger",
                    accept: acceptInsertConfig,
                    reject: rejectInsertConfig,
                    });
  }

  const acceptInsertConfig  = () => {
   if(selectedColumns.length > 0) {
      let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        id_config: 274 + izabranPregled,
        parametri: selectedColumns
      }),
    };
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/config/changeConfig", requestOptions)
      .then(handleErrors)
      .then((data) => {

            if(data.message && data.message == 'Nema izmena u podacima konfiguracije pregleda.'){
                toast.current.show({
                    severity: "warn",
                    summary: t('admin.m_upozorenje_2'),
                    detail: data.message,
                    life: 3000,
                    });
                return
                }  
  
            toast.current.show({
                severity: "success",
                summary: t('admin.m_uspesna_izmena_konfiguracije_pregleda_za_5'),
                life: 3000,
            });

      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      }); 
    } else {
        toast.current.show({
                    severity: "warn",
                    summary: t('admin.m_upozorenje_2'),
                    detail: t('admin.m_morate_imati_barem_1_izabranu_stavku'),
                    life: 3000,
                    });
    }
  }
  const rejectInsertConfig = () => {
    console.log('Config insert rejected!')
  }

  const handleChangePIB = (e) => {
    if(e.target.value.length <= 9){
    setPIB(e.target.value)
    }
}

const povuciBonitet = async () => {
        if(pib == null) {
          toast.current.show({
                                severity: "warn",
                                summary: t('admin.m_upozorenje_2'),
                                detail: t('admin.m_niste_uneli_pib_pib_mora_imati_9_brojeva'),
                                life: 3000,
                            });
                            return
    }
            if(pib.length < 9){
                toast.current.show({
                                severity: "warn",
                                summary: t('admin.m_upozorenje_2'),
                                detail: t('admin.m_niste_uneli_kompletan_pib_pib_mora_imati'),
                                life: 3000,
                            });
            } else {
                      let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                pib: parseInt(pib)
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/bonitet/CompanyByPIB", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.error){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.error,
                                    life: 3000,
                                    });
                                    return
                                }  
                                
                                if(data.message){
                                    toast.current.show({
                                    severity: "warn",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                }
                                setBonitetData(data);
                                setConfirmVisible(true);
                              
                              setPIB(null)
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
    }
}

  const odbijPovlacenjeBoniteta = () => {
    console.log('Bonitet check rejected!')
  }

const handleCheckBonitet = () => {
         confirmDialog({
                    message: "Jel ste sigurni da želite proveriti podatke kompanije?",
                    acceptLabel: "Da",
                    rejectLabel: "Ne",
                    icon: "pi pi-info-circle",
                    acceptClassName: "p-button-danger",
                    accept: povuciBonitet,
                    reject: odbijPovlacenjeBoniteta,
                    });
  }

  const processBonitetForCompany = async (data) => {
                                props.setBonitetData(data);
                                props.setChangeView(4);
                                setBonitetData(null);
                                setConfirmVisible(false);
                                setPIB(null)                                
                                document.getElementById('PIBbonitet').value = '';
  };

  const handleReject = () => {
      setPIB(null)
      document.getElementById('PIBbonitet').value = '';
    setConfirmVisible(false);
    setBonitetData(null);
  
  };

  const acceptInsertBonitetAndClient = async () => {
    try {
      await processBonitetForCompany(bonitetData);
      setConfirmVisible(false);
      setBonitetData(null);
    } catch (e) {
      toast.current?.show({
        severity: 'error',
        summary: t('admin.m_greska'),
        detail: t('admin.m_upis_u_bazu_nije_uspeo'),
        life: 3000
      });
    }
  };

  return (
    <>
          <div className="">
                            <div className="gridHeader klijent-red" style={{marginTop:'1%'}}>
                                    <h4>Proveri bonitet:</h4>
                                     <InputText style={{ width: "15%" }} id="PIBbonitet" name="PIB" value={pib} onChange={handleChangePIB} placeholder={t('admin.unesiPib')}/>
                        <Button label={t('admin.proveri')} className="mt-3 zaposleniShift" onClick={handleCheckBonitet} />
                        </div>

                            {/* Isti raspored kao red iznad — labela pa kontrola u istoj liniji */}
                            <div className="gridHeader klijent-red">
                                    <h4>{t('admin.phPregled')}:</h4>
                                    <Dropdown required id="tipPregleda" name="tipPregleda" style={{ width: "15%" }} value={izabranPregled} options={pregledOptions} onChange={handleChangePregled} placeholder={t('common.choose')} />
                            </div>
                    </div>
        <div style={{borderTop: '1px solid rgb(224, 221, 221)', minWidth:'100%'}}></div>
    <div className="zaposleni_table_container">
    
      <Toast ref={toast} />
      <ConfirmDialog />
      
      <ConfirmationModalBonitet
        visible={confirmVisible}
        onHide={() => {setConfirmVisible(false); document.getElementById('PIBbonitet').value = ''; }}
        onConfirm={acceptInsertBonitetAndClient}
        onReject={handleReject}
        message="Da li želite da sačuvate klijenta i bonitetne podatke u bazu?"
        data={bonitetData}
      />
      
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "1em" }}>
                <div style={{ width: "20%" }}>
                  {allColumns.length > 0 && (
                    <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>  <MultiSelect
                      value={selectedColumns}
                      options={allColumns}
                      onChange={(e) => {
          const sorted = originalColumnOrder.filter((key) => e.value.includes(key));
          setSelectedColumns(sorted);
        }}
                      optionLabel="label"
                      display="chip"
                      placeholder={t('nova.odaberiteKolone')}
                      style={{ width: '100%' }}
                      showSelectAll={true}
                      filter
                      filterPlaceholder="Pretraži kolone"
                      maxSelectedLabels={3}
                      selectedItemsLabel="{0} kolona odabrano"
                    />
                    <button onClick={handleSaveConfig} style={{marginLeft:'1%'}} className="configSaveButton"><i className="pi pi-save"></i></button></div>
                  
                  )}
                </div>
                 {(izabran) && <p class="infoPoruka" style={{margin: '0', display: 'flex', alignItems: 'center'}}>Subjekat je selektovan. Moguće ažuriranje njegovih podataka.</p>}
      </div>
      <Tooltip target=".export-buttons>button" position="bottom" />
      <div ref={omotTabele}>
      <DataTable className="stavke-tabela"
        value={tableData}
        paginator
        rows={redovaTabele}
        header={header}
        first={first}
        globalFilter={globalFilter}
        onPage={(e) => setFirst(e.first)}
        scrollable
        scrollHeight={visinaTabele}
        emptyMessage={t('common.noDataTable')}
        loading={tableData === null}
        resizableColumns
        columnResizeMode="expand"
      >
         {selectedColumns.map((colKey) => {
               const colMeta = allColumns.find(col => col.value === colKey);
               return (
                 <Column
                   key={colKey}
                   field={colKey}
                   header={translateCol(t, colMeta?.label || colKey)}
                   sortable
                   body={(rowData) => {
                     return rowData[colKey] || '-';
                   }}
                   style={{ minWidth: '150px'}}
                 />
               );
             })}
      </DataTable>
      </div>
    </div>
     </>
  );
};

export default BonitetProvera;